<template>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="row">
                <div class="col-xs-6">
                    <h1>Edit Discount for Campaign ( {{ campaignDetails.name }} )</h1>
                </div>
                <div class="col-xs-6 mandatoryDiv">
                    <span class="mandatory_color">(*)</span>
                    <span class="letter-right"> Marked are required field</span>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="alert alert-info" v-if="alert_message">
                        {{ alert_message }}
                    </div>
                    <div class="alert alert-danger" v-if="error_message">
                        {{ error_message }}
                    </div>
                </div>
                <form @submit.prevent="formSubmit">
                    <div class="col-sm-6">
                        <div class="box">
                            <div class="box-header">
                                <h3 class="box-title">Subscription Package</h3>
                            </div>
                            <div class="box-body form-box-body form-horizontal">
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Coupon Code <span
                                            class="mandatory_horizontal">*</span></label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control input-sm"
                                            :value="campaignDetails.coupon_code" readonly />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Package Name <span
                                            class="mandatory_horizontal">*</span></label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control input-sm"
                                            :value="ratePlanDetails.plan_name" readonly />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Number Of Days <span
                                            class="mandatory_horizontal">*</span></label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control input-sm"
                                            :value="ratePlanDetails.no_of_days" readonly />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Package Price <span
                                            class="mandatory_horizontal">*</span></label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control input-sm" :value="ratePlanDetails.price"
                                            readonly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="box">
                            <div class="box-header">
                                <h3 class="box-title">Apply Discount</h3>
                            </div>
                            <div class="box-body form-box-body form-horizontal">
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Discount Amount <span
                                            class="mandatory_horizontal">*</span></label>
                                    <div class="col-md-8">
                                        <input type="number" v-model="formData.discount_amount" id="discount_amount"
                                            name="discount_amount" placeholder="Discount Amount" min="0" step="0.01"
                                            required class="form-control input-sm" />
                                        <small v-if="errors.discount_amount" class="text-danger">{{
                                            errors.discount_amount }}</small>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Discount Type <span
                                            class="mandatory_horizontal">*</span></label>
                                    <div class="col-md-8">
                                        <label class="radio-inline">
                                            <input type="radio" v-model="formData.discount_type" value="1"
                                                name="discount_type" /> Fixed
                                        </label>
                                        <label class="radio-inline">
                                            <input type="radio" v-model="formData.discount_type" value="2"
                                                name="discount_type" /> Percentage
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Extra Bonus Validity (days)</label>
                                    <div class="col-md-8">
                                        <input type="number" v-model="formData.extra_bonus_validity_in_days"
                                            id="extra_bonus_validity_in_days" name="extra_bonus_validity_in_days"
                                            placeholder="No Of Days: 0" min="0" class="form-control input-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 btnCenter">
                            <input type="submit" name="submit" value="Update"
                                class="btn btn-sm btn-submit btn-submit-big" />
                            <router-link
                                :to="{ name: 'CampaignCouponDiscountList', params: { id: campaignDetails.id } }"
                                class="btn btn-sm btn-cancel">
                                Cancel
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "CampaignCouponDiscountForm",
    data() {
        return {
            discountId: null,
            campaignDetails: {},
            ratePlanDetails: {},
            alert_message: "",
            error_message: "",
            formData: {
                discount_type: "1",
                discount_amount: "",
                extra_bonus_validity_in_days: 0,
            },
            errors: {},
        };
    },
    created() {
        this.com_user_type_access([0, 5, 6, 7], true);
        this.discountId = this.$route.params.id;
        if (this.discountId) {
            this.loadDiscountData();
        }
    },
    methods: {
        loadDiscountData() {
            loader.show();
            axios
                .get("/campaign-discounts/" + this.discountId)
                .then((response) => {
                    let data = response.data.result;
                    this.campaignDetails = data.campaign || {};
                    this.ratePlanDetails = data.rate_plan_detail || {};
                    this.formData.discount_type = data.discount_type || "1";
                    this.formData.discount_amount = data.discount_amount || "";
                    this.formData.extra_bonus_validity_in_days = data.extra_bonus_validity_in_days || 0;
                    loader.hide();
                })
                .catch((error) => {
                    loader.hide();
                    this.com_errorHandel(error);
                });
        },
        formValidation() {
            this.errors = {};
            let validationFlag = false;

            if (!this.formData.discount_amount && this.formData.discount_amount !== 0) {
                this.errors.discount_amount = "Please enter discount amount";
                validationFlag = true;
            }
            if (!this.formData.discount_type) {
                this.errors.discount_type = "Please select discount type";
                validationFlag = true;
            }

            return validationFlag;
        },
        formSubmit() {
            if (this.formValidation()) {
                return;
            }

            let rootObject = this;
            loader.show();

            axios
                .put("/campaign-discounts/" + this.discountId, this.formData)
                .then(function (response) {
                    if (response.data.result) {
                        rootObject.alert_message = response.data.message || "Discount Updated Successfully";
                        setTimeout(() => {
                            rootObject.$router.push({
                                name: "CampaignCouponDiscountList",
                                params: { id: rootObject.campaignDetails.id },
                            });
                        }, 1500);
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    loader.hide();
                    if (error.response && error.response.data) {
                        rootObject.error_message = error.response.data.message || "Failed to update discount";
                    }
                    rootObject.com_errorHandel(error);
                });
        },
    },
};
</script>

<style scoped>
.text-danger {
    color: red;
}
</style>